var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import StageForm from "./StageForm";
import StageService from "../../../Services/Stage.service";
import StageTypeDomainService from "../../../Domain/StageType/StageType.service";
const CreateStageModal = (_a) => {
    var { pipelineId } = _a, modalProps = __rest(_a, ["pipelineId"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Add a Stage", defaultValue: {
            id: null,
            name: "",
            description: null,
            isEndingStage: false,
        }, handleSubmit: (state) => {
            var _a, _b;
            return StageService.create({
                name: state.name,
                description: state.description,
                stageTypeId: (_b = (_a = state.stageType) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : StageTypeDomainService.NONE_ID,
                pipelineId,
            });
        }, children: _jsx(StageForm, {}) })));
};
export default CreateStageModal;
